import { AzavistaApiService, GroupedFieldsViewGlobalEntityType, IGroupedFieldsView } from '@azavista/servicelib';
import { IGroupedFieldsViewManager } from './interfaces';

export class GlobalGroupedFieldsViewManager implements IGroupedFieldsViewManager {
    private globalEntityType: GroupedFieldsViewGlobalEntityType;

    constructor(private apiSvc: AzavistaApiService) {
    }

    init(config: { globalEntityType: GroupedFieldsViewGlobalEntityType }): void {
        this.globalEntityType = config.globalEntityType;
    }

    async getViews(): Promise<IGroupedFieldsView[]> {
        return await this.apiSvc.getGlobalViews(this.globalEntityType);
    }

    async createView(view: IGroupedFieldsView): Promise<IGroupedFieldsView> {
        return await this.apiSvc.createGlobalView(this.globalEntityType, view);
    }

    async updateView(view: IGroupedFieldsView): Promise<IGroupedFieldsView> {
        return await this.apiSvc.updateGlobalView(this.globalEntityType, view);
    }

    async deleteView(viewId: string): Promise<void> {
        await this.apiSvc.deleteGlobalView(this.globalEntityType, viewId);
    }
}
